import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl'; // 다국어 지원 추가
import PropTypes from 'prop-types'; // prop-types 추가
import {
  getSiteSubProperties,
  searchProperties, // 추가
  updateSiteSubProperties, // 추가
  getNeighborhoods, // 추가
  createPropertyAndLink, // 추가
} from '../../services/CommonServices';
import numeral from 'numeral'; // 가격 포맷팅 위해 추가
import LoginStore from '../../stores/LoginStore'; // 로그인 스토어 임포트
import Constants from '../../constants/Constants'; // 상수 임포트
import IntlObject from '../Common/IntlObject'; // IntlObject 임포트
import { Modal, Button, Form, ListGroup, InputGroup, FormControl, Spinner, Alert, ButtonGroup, Tabs, Tab, Row, Col } from 'react-bootstrap'; // React Bootstrap 컴포넌트 사용, ButtonGroup 추가, Tabs, Tab, Row, Col 추가

// styled-components 정의 (PropertiesContainer.js의 스타일 일부 참고 및 조정)
const PropertyGridContainer = styled.section`
  position: relative; // 편집 버튼 위치 잡기 위해 추가

  // .bm-card 스타일과 유사하게 카드 스타일 정의
  .property-card {
    border: 1px solid #eee;
    border-radius: 0.25rem;
    overflow: hidden; // 이미지 등이 넘치지 않도록
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    transition: box-shadow 0.3s ease-in-out;

    &:hover {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }

    .card-img-top {
      height: 200px; // 이미지 높이 고정 (조정 가능)
      object-fit: cover; // 이미지가 비율 유지하며 꽉 차도록
    }

    .card-body {
      text-align: left;
    }

    .card-title {
      font-size: 1.1rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
      // 텍스트가 너무 길 경우 ... 처리 (선택 사항)
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-text {
      font-size: 0.9rem;
      margin-bottom: 0.25rem;
    }

    .text-sm {
      font-size: 0.8rem;
    }
  }

  // 추가적인 전역 스타일이 필요하면 여기에 정의
`;

// 편집 패널 스타일
const EditPanelStyles = styled(Modal.Body)`
  max-height: 70vh;
  padding-top: 0; // 탭 아래 패딩 제거

  .tab-content {
    padding-top: 1rem; // 탭 내용 상단 패딩
    height: calc(70vh - 50px); // 헤더/푸터 제외한 대략적인 높이, 조정 필요
    display: flex; // 탭 내용을 flex로 만들어 내부 섹션 배치
    gap: 20px;
  }

  .search-section, .selected-section, .add-form-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .list-group-scrollable {
    flex-grow: 1;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    min-height: 100px; // 최소 높이 설정
  }

  .list-group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;

    img {
      width: 40px;
      height: 30px;
      object-fit: cover;
      margin-right: 10px;
      flex-shrink: 0; // 이미지 크기 유지
    }

    .property-info {
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }

    .btn-group .btn,
    .btn-sm {
      padding: 0.15rem 0.4rem; // 버튼 패딩 조정
      font-size: 0.75rem; // 버튼 폰트 크기 조정
    }
  }
`;

function PropertiesContainerType02(props) {
  const { intl, id: siteSubId, objects: objectsString } = props;
  const [displayedProperties, setDisplayedProperties] = useState([]); // 화면에 표시되는 매물
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [authInfo, setAuthInfo] = useState(LoginStore.authInfo);

  // --- 편집 관련 상태 --- 
  const [isEditing, setIsEditing] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [priceSearch, setPriceSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [saveError, setSaveError] = useState(null);

  // --- 새 매물 추가 관련 상태 ---
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [neighborhoodLoading, setNeighborhoodLoading] = useState(false);
  const [newPropertyData, setNewPropertyData] = useState({}); // 새 매물 폼 데이터
  const [addPropertyLoading, setAddPropertyLoading] = useState(false);
  const [addPropertyError, setAddPropertyError] = useState(null);
  // --- 새 매물 추가 관련 상태 끝 ---

  // LoginStore 변경 감지 리스너 설정
  useEffect(() => {
    const handleLoginChange = () => {
      setAuthInfo(LoginStore.authInfo);
    };
    LoginStore.addChangeListener(handleLoginChange);
    return () => {
      LoginStore.removeChangeListener(handleLoginChange);
    };
  }, []);

  const isLogin = authInfo?.status === Constants.AUTHED;

  const loadDisplayedProperties = useCallback(() => {
    if (!siteSubId) {
      setError(intl.formatMessage({ id: 'error.missing_site_sub_id', defaultMessage: 'SiteSub ID가 누락되었습니다.' }));
      setLoading(false);
      return;
    }
    setLoading(true);
    getSiteSubProperties(siteSubId)
      .then(res => {
        if (res.data && res.data.success) {
          setDisplayedProperties(res.data.properties || []);
          setError(null);
        } else {
          setError(res.data.message || intl.formatMessage({ id: 'error.failed_load_properties', defaultMessage: '매물 정보를 불러오는데 실패했습니다.' }));
          setDisplayedProperties([]);
        }
      })
      .catch(err => {
        console.error("Error fetching properties:", err);
        setError(intl.formatMessage({ id: 'error.network_load_properties', defaultMessage: '네트워크 오류 또는 서버 문제로 매물 정보를 불러올 수 없습니다.' }));
        setDisplayedProperties([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [siteSubId, intl]);

  useEffect(() => {
    loadDisplayedProperties();
  }, [loadDisplayedProperties]);

  // --- 편집 관련 함수 ---
  const handleOpenEditModal = () => {
    // 동네 목록 로드
    setNeighborhoodLoading(true);
    getNeighborhoods()
      .then(res => {
        if (res.data && res.data.success) {
          setNeighborhoods(res.data.neighborhoods || []);
        } else {
          console.error("Failed to load neighborhoods");
        }
      })
      .catch(err => console.error("Error loading neighborhoods:", err))
      .finally(() => setNeighborhoodLoading(false));

    // 기존 매물 목록 로드 (기존 로직과 동일)
    setLoading(true);
    getSiteSubProperties(siteSubId)
      .then(res => {
        if (res.data && res.data.success) {
          setSelectedProperties(res.data.properties || []);
        } else {
          setSelectedProperties([]); // 실패 시 빈 배열로 시작
          alert("현재 매물 목록을 불러오는데 실패했습니다. 빈 목록에서 시작합니다.");
        }
      })
      .catch(err => {
         setSelectedProperties([]);
         alert("현재 매물 목록을 불러오는데 실패했습니다. 빈 목록에서 시작합니다.");
      })
      .finally(() => {
          setLoading(false);
          setSearchTerm('');
          setPriceSearch('');
          setSearchResults([]);
          setSearchError(null);
          setSaveError(null);
          setNewPropertyData({}); // 새 매물 폼 초기화
          setAddPropertyError(null);
          setIsEditing(true);
      });
  };

  const handleCloseEditModal = () => {
    setIsEditing(false);
  };

  const handleSearch = useCallback(async () => {
    setSearchLoading(true);
    setSearchError(null);
    setSearchResults([]);
    try {
      const params = { limit: 20 };
      if (searchTerm) params.q = searchTerm;
      const priceNum = parseFloat(priceSearch);
      if (!isNaN(priceNum)) {
        params.price_lte = priceNum;
      }

      const res = await searchProperties(params);
      if (res.data && res.data.success) {
        setSearchResults(res.data.properties || []);
      } else {
        setSearchError(res.data.message || 'Search failed');
      }
    } catch (err) {
      console.error("Search error:", err);
      setSearchError('Failed to search properties.');
    } finally {
      setSearchLoading(false);
    }
  }, [searchTerm, priceSearch]);

  const handleAddProperty = (propertyToAdd) => {
    if (!selectedProperties.some(p => p.id === propertyToAdd.id)) {
      setSelectedProperties(prev => [...prev, propertyToAdd]);
    } else {
      alert('이미 추가된 매물입니다.');
    }
  };

  const handleRemoveProperty = (propertyIdToRemove) => {
    setSelectedProperties(prev => prev.filter(p => p.id !== propertyIdToRemove));
  };

  const handleMoveProperty = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= selectedProperties.length) return;
    const newList = [...selectedProperties];
    [newList[index], newList[newIndex]] = [newList[newIndex], newList[index]];
    setSelectedProperties(newList);
  };

  const handleSaveChanges = async () => {
    setSaveLoading(true);
    setSaveError(null);
    try {
      const propertiesToSave = selectedProperties.map((p, index) => ({ propertyId: p.id, order: index }));
      const res = await updateSiteSubProperties(siteSubId, propertiesToSave);
      if (res.data && res.data.success) {
        setIsEditing(false);
        loadDisplayedProperties();
      } else {
        setSaveError(res.data.message || 'Failed to save changes.');
      }
    } catch (err) {
      console.error("Save error:", err);
      setSaveError('Failed to save changes.');
    } finally {
      setSaveLoading(false);
    }
  };

  // --- 새 매물 추가 관련 함수 ---
  const handleNewPropertyInputChange = (event) => {
    const { name, value } = event.target;
    setNewPropertyData(prev => ({ ...prev, [name]: value }));
  };

  const handleAddNewProperty = async (event) => {
    event.preventDefault();
    setAddPropertyLoading(true);
    setAddPropertyError(null);
    try {
      const res = await createPropertyAndLink(siteSubId, newPropertyData);
      if (res.data && res.data.success) {
        alert('새 매물이 추가되고 목록에 반영되었습니다.');
        // 성공 시, 새로 생성된 매물을 selectedProperties에 추가
        if (res.data.newProperty) {
          setSelectedProperties(prev => [...prev, res.data.newProperty]);
        }
        setNewPropertyData({}); // 폼 초기화
        // 필요하다면 탭 전환 로직 추가
      } else {
        setAddPropertyError(res.data.message || 'Failed to add new property.');
      }
    } catch (err) {
      console.error("Add new property error:", err);
      setAddPropertyError('Failed to add new property.');
    } finally {
      setAddPropertyLoading(false);
    }
  };
  // --- 새 매물 추가 관련 함수 끝 ---

  const renderPropertyCard = (property) => {
    const formattedPrice = property.price
      ? `${property.price_unit || '$'}${numeral(property.price).format('0,0')}` // numeral 사용 및 단위 추가
      : intl.formatMessage({ id: 'properties.price_on_request', defaultMessage: '가격 문의' });

    const imageUrl = property.pic || 'https://via.placeholder.com/300x200?text=No+Image';
    const altText = property.title || intl.formatMessage({ id: 'properties.image_alt', defaultMessage: '부동산 매물 이미지' });

    return (
      <div key={property.id} className="col-md-6 col-lg-4 mb-4">
        <div className="card h-100 property-card">
          {/* 링크 추가 가능성 고려 (예: property 상세 페이지) */}
          {/* <a href={`/property/${property.id}`} style={{ textDecoration: 'none', color: 'inherit' }}> */}
          <img src={imageUrl} className="card-img-top" alt={altText} />
          <div className="card-body d-flex flex-column">
            <h5 className="card-title" title={property.title || ''}>{property.title || intl.formatMessage({ id: 'properties.no_title', defaultMessage: '제목 없음' })}</h5>
            <p className="card-text text-muted flex-grow-1">{property.address || intl.formatMessage({ id: 'properties.no_address', defaultMessage: '주소 정보 없음' })}</p>
            <p className="card-text">
              <strong>{formattedPrice}</strong>
            </p>
            <div className="d-flex justify-content-between text-sm text-muted">
              {/* Intl 사용 예시 */}
              <span>{property.bedrooms ? `${property.bedrooms} ${intl.formatMessage({ id: 'properties.label.beds', defaultMessage: '침실' })}` : ''}</span>
              <span>{property.full_baths ? `${property.full_baths} ${intl.formatMessage({ id: 'properties.label.baths', defaultMessage: '욕실' })}` : ''}</span>
              <span>{property.style || ''}</span>
            </div>
            {/* 필요한 경우 버튼 추가 */}
            {/* <a href={`/property/${property.id}`} className="btn btn-sm btn-outline-primary mt-auto">상세 보기</a> */}
          </div>
          {/* </a> */}
        </div>
      </div>
    );
  };

  console.log('PropertiesContainerType02 - isLogin:', isLogin); // 로그 추가
  console.log('PropertiesContainerType02 - authInfo:', authInfo); // authInfo 상태도 확인
  console.log('PropertiesContainerType02 - Constants.AUTHED:', Constants.AUTHED); // 비교 대상 상수 값 확인

  return (
    <PropertyGridContainer className="site-sub-section properties-container-02 py-5">
      {isLogin && (
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handleOpenEditModal}
          style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}
        >
          매물 관리
        </Button>
      )}

      <div className="container">
        {/* EditableObjectHandle 추가 가능성 고려 (예: 섹션 배경색 등 objects 필드 편집용) */}
        {/* <EditableObjectHandle id={siteSubId} objects={objectsString} isAdmin={isLogin} componentTitle="PropertiesContainerType02" /> */}

        {/* 섹션 제목을 IntlObject로 변경 */}
        <h2 className="text-center mb-4">
          <IntlObject
            keycode={`properties.type03.title`}
            defaultMessage='부동산 매물 리스트' // 기본값 제공
            isAdmin={isLogin}
            isLogin={isLogin} // isLogin prop 추가 (IntlObject가 요구할 수 있음)
          />
        </h2>

        {loading && (
          <div className="text-center">
            {intl.formatMessage({ id: 'status.loading', defaultMessage: '로딩 중...' })}
          </div>
        )}
        {error && <div className="alert alert-danger">{error}</div>}

        {!loading && !error && displayedProperties.length === 0 && (
          <div className="text-center text-muted">
            {intl.formatMessage({ id: 'properties.no_properties_found', defaultMessage: '표시할 매물이 없습니다.' })}
          </div>
        )}

        {!loading && !error && displayedProperties.length > 0 && (
          <div className="row">
            {displayedProperties.map(renderPropertyCard)}
          </div>
        )}
      </div>

      {/* 편집 모달 */}
      <Modal show={isEditing} onHide={handleCloseEditModal} size="xl" centered backdrop="static"> {/* backdrop static 추가 */} 
        <Modal.Header closeButton>
          <Modal.Title>매물 목록 관리</Modal.Title>
        </Modal.Header>
        <EditPanelStyles>
          <Tabs defaultActiveKey="search" id="property-edit-tabs" mountOnEnter> {/* mountOnEnter 추가 */}

            {/* 탭 1: 검색 및 관리 */}
            <Tab eventKey="search" title="매물 검색/관리">
              <div className="search-section border-end pe-3">
                <h5>매물 검색</h5>
                <Form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                  <InputGroup className="mb-2">
                    <FormControl
                      placeholder="MLS ID, 주소, 제목 검색"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </InputGroup>
                  <InputGroup className="mb-2">
                     <InputGroup.Text>$</InputGroup.Text>
                     <FormControl
                        type="number"
                        placeholder="가격 이하 검색 (예: 500000)"
                        value={priceSearch}
                        onChange={(e) => setPriceSearch(e.target.value)}
                      />
                    <Button variant="outline-secondary" type="submit" disabled={searchLoading}>
                      {searchLoading ? <Spinner as="span" animation="border" size="sm" /> : '검색'}
                    </Button>
                  </InputGroup>
                </Form>
                {searchError && <Alert variant="warning" size="sm">{searchError}</Alert>}
                <h6>검색 결과 ({searchResults.length})</h6>
                <div className="list-group-scrollable">
                   <ListGroup variant="flush">
                      {!searchLoading && searchResults.length === 0 && <ListGroup.Item className="text-center text-muted">검색 결과가 없습니다.</ListGroup.Item>}
                      {!searchLoading && searchResults.map(prop => (
                         <ListGroup.Item key={`search-${prop.id}`}>
                            <img src={prop.pic || 'https://via.placeholder.com/40x30?text=N/A'} alt="thumb"/>
                            <span className="property-info" title={`${prop.title || ''} (${prop.address || ''})`}>
                              {prop.title || '-'} ({prop.address || '-'}) - ${numeral(prop.price).format('0,0')}
                            </span>
                            <Button variant="success" size="sm" onClick={() => handleAddProperty(prop)} disabled={selectedProperties.some(p => p.id === prop.id)}>+</Button> {/* 중복 추가 방지 */} 
                         </ListGroup.Item>
                      ))}
                   </ListGroup>
                </div>
              </div>
              <div className="selected-section">
                 <h5>선택된 매물 목록 ({selectedProperties.length})</h5>
                  <div className="list-group-scrollable">
                    <ListGroup>
                      {selectedProperties.length === 0 && <ListGroup.Item className="text-center text-muted">선택된 매물이 없습니다.</ListGroup.Item>}
                      {selectedProperties.map((prop, index) => (
                         <ListGroup.Item key={`selected-${prop.id}`}>
                            <img src={prop.pic || 'https://via.placeholder.com/40x30?text=N/A'} alt="thumb"/>
                            <span className="property-info" title={`${prop.title || ''} (${prop.address || ''})`}>
                               {index + 1}. {prop.title || '-'} ({prop.address || '-'})
                            </span>
                            <ButtonGroup size="sm" className="me-2">
                              <Button variant="outline-secondary" onClick={() => handleMoveProperty(index, -1)} disabled={index === 0}>▲</Button>
                              <Button variant="outline-secondary" onClick={() => handleMoveProperty(index, 1)} disabled={index === selectedProperties.length - 1}>▼</Button>
                            </ButtonGroup>
                            <Button variant="danger" size="sm" onClick={() => handleRemoveProperty(prop.id)}>-</Button>
                         </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
              </div>
            </Tab>

            {/* 탭 2: 새 매물 추가 */}
            <Tab eventKey="add" title="새 매물 추가">
              <div className="add-form-section">
                <h5>새 부동산 매물 정보 입력</h5>
                {addPropertyError && <Alert variant="danger">{addPropertyError}</Alert>}
                <Form onSubmit={handleAddNewProperty} style={{ flexGrow: 1, overflowY: 'auto', paddingRight: '15px' }}>
                  {/* 필수 필드 예시 */}
                  <Row>
                    <Form.Group as={Col} md="8" className="mb-3" controlId="formAddress">
                      <Form.Label>주소*</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={newPropertyData.address || ''}
                        onChange={handleNewPropertyInputChange}
                        required
                      />
                    </Form.Group>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formMLS">
                       <Form.Label>MLS ID</Form.Label>
                       <Form.Control type="text" name="mls_id" value={newPropertyData.mls_id || ''} onChange={handleNewPropertyInputChange} />
                     </Form.Group>
                  </Row>
                  <Form.Group className="mb-3" controlId="formTitle">
                    <Form.Label>제목*</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={newPropertyData.title || ''}
                      onChange={handleNewPropertyInputChange}
                      required
                    />
                  </Form.Group>
                  <Row>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formPrice">
                       <Form.Label>가격*</Form.Label>
                       <InputGroup>
                         <InputGroup.Text>$</InputGroup.Text>
                         <Form.Control type="number" name="price" step="0.01" value={newPropertyData.price || ''} onChange={handleNewPropertyInputChange} required />
                       </InputGroup>
                       {/* 가격 단위 필드 추가 가능 */}
                     </Form.Group>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formNeighborhood">
                        <Form.Label>동네</Form.Label>
                        <Form.Select name="neighborhood" value={newPropertyData.neighborhood || ''} onChange={handleNewPropertyInputChange} disabled={neighborhoodLoading}>
                           <option value="">동네 선택...</option>
                           {neighborhoods.map(n => <option key={n.id} value={n.id}>{n.neighborhood}{n.borough ? ` (${n.borough})` : ''}</option>)}
                        </Form.Select>
                     </Form.Group>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formStyle">
                        <Form.Label>스타일</Form.Label>
                        <Form.Control type="text" name="style" value={newPropertyData.style || ''} onChange={handleNewPropertyInputChange} />
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formBedrooms">
                       <Form.Label>침실 수</Form.Label>
                       <Form.Control type="number" name="bedrooms" value={newPropertyData.bedrooms || ''} onChange={handleNewPropertyInputChange} />
                     </Form.Group>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formFullBaths">
                        <Form.Label>욕실 (Full)</Form.Label>
                        <Form.Control type="number" name="full_baths" value={newPropertyData.full_baths || ''} onChange={handleNewPropertyInputChange} />
                     </Form.Group>
                     <Form.Group as={Col} md="4" className="mb-3" controlId="formHalfBaths">
                        <Form.Label>욕실 (Half)</Form.Label>
                        <Form.Control type="number" name="half_baths" value={newPropertyData.half_baths || ''} onChange={handleNewPropertyInputChange} />
                     </Form.Group>
                  </Row>
                  <Form.Group className="mb-3" controlId="formDescription">
                      <Form.Label>설명 (원본)</Form.Label>
                      <Form.Control as="textarea" rows={3} name="desc_original" value={newPropertyData.desc_original || ''} onChange={handleNewPropertyInputChange} />
                  </Form.Group>
                  {/* 이미지, 비디오 등 다른 필드 추가 */}
                  <Form.Group className="mb-3" controlId="formPic">
                      <Form.Label>대표 이미지 URL</Form.Label>
                      <Form.Control type="text" name="pic" value={newPropertyData.pic || ''} onChange={handleNewPropertyInputChange} placeholder="https://..." />
                  </Form.Group>

                  <Button variant="primary" type="submit" disabled={addPropertyLoading}>
                    {addPropertyLoading ? <Spinner as="span" animation="border" size="sm"/> : '새 매물 추가 및 목록 반영'}
                  </Button>
                </Form>
              </div>
            </Tab>

          </Tabs>
        </EditPanelStyles>
        <Modal.Footer>
          {saveError && <Alert variant="danger" className="me-auto p-1">{saveError}</Alert>} {/* p-1 추가 */} 
          <Button variant="secondary" onClick={handleCloseEditModal} disabled={saveLoading}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={saveLoading}>
            {saveLoading ? <Spinner as="span" animation="border" size="sm" /> : '변경사항 저장'}
          </Button>
        </Modal.Footer>
      </Modal>

    </PropertyGridContainer>
  );
}

// PropTypes 정의
PropertiesContainerType02.propTypes = {
  intl: PropTypes.object.isRequired, // injectIntl로 주입됨
  id: PropTypes.number.isRequired, // site_sub_id
  objects: PropTypes.string, // JSON 문자열
};

// injectIntl로 감싸서 export
export default injectIntl(PropertiesContainerType02); 